/**
 * חישוב שעות של משמרת.
 *
 * במקום אחד, כי אותו חישוב נדרש בשלושה מקומות (מגש המשמרת,
 * רשימת הצוות, והסיכום החודשי בשרת), וכל עותק שלו הוא הזדמנות
 * לשכוח את חציית חצות.
 */

/**
 * משך המשמרת בדקות. `HH:MM` או `HH:MM:SS`.
 *
 * משמרת שנגמרת לפני שהיא מתחילה חוצה את חצות. בלי זה משמרת
 * 22:00–06:00 היתה מחושבת כמינוס שש עשרה שעות, והסיכום השבועי
 * היה קטן ממה שאדם באמת עבד.
 */
export function shiftMinutes(start: string, end: string): number {
  const toMinutes = (time: string) => {
    const [hours, minutes] = time.split(':');
    return Number(hours) * 60 + Number(minutes);
  };

  const diff = toMinutes(end) - toMinutes(start);
  return diff > 0 ? diff : diff + 24 * 60;
}

/** "6:15 שעות", "שעה", "45 דקות". */
export function formatHours(minutes: number): string {
  if (minutes <= 0) return 'אין שעות';
  if (minutes < 60) return `${minutes} דקות`;

  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;

  if (rest === 0) {
    return hours === 1 ? 'שעה' : `${hours} שעות`;
  }
  return `${hours}:${String(rest).padStart(2, '0')} שעות`;
}

/** "ללא משמרות", "משמרת אחת", "3 משמרות". */
export function shiftsLabel(count: number): string {
  if (count === 0) return 'ללא משמרות';
  if (count === 1) return 'משמרת אחת';
  return `${count} משמרות`;
}
